import {Component, OnInit, ViewChild} from '@angular/core';
import mockedAixmCatalogue from './../mocked-aixm-catalogue.json';
import {ActivatedRoute} from "@angular/router";
import {MatTree} from "@angular/material/tree";
import {NestedTreeControl} from "@angular/cdk/tree";

interface IFeatureOption {
    label: string;
    value: string;
}

interface TreeNode {
    name: string;
    children?: TreeNode[];
}


@Component({
    selector: 'property-group-view',
    templateUrl: './property-group-view.component.html',
    styleUrls: ['./property-group-view.component.css']
})
export class PropertyGroupViewComponent implements OnInit {
    featureName: string;
    propertyGroupName: string;
    metadataExpanded: boolean = false;
    @ViewChild(MatTree) tree: MatTree<TreeNode>;
    treeData: any = [];
    treeControl = new NestedTreeControl<TreeNode>(node => node.children);

    constructor(private route: ActivatedRoute) {}

    toggleMetadata(): void {
        this.metadataExpanded = !this.metadataExpanded;
    }

    ngAfterViewInit() {
        this.expandAllNodes(this.treeData);
    }

    expandAllNodes(nodes: any[]) {
        if (!nodes) return;
        for (const node of nodes) {
            if (node.children && node.children.length > 0) {
                console.log('NODE: ', node);
                this.tree.treeControl.expand(node);
                this.expandAllNodes(node.children); // Recursively expand children
            }
        }
    }

    childrenAccessor = (node: any) => node.children;
    hasChild = (_: number, node: any) => !!node.children && node.children.length > 0;

    mapTreeData(): void {
        if (this.propertyGroupName?.includes('TimeSliceType')) {
            this.treeData = [
                {
                    //name: '<a href={"/#/data-catalogue/feature/" + this.id + "/property-group/" + this.matchingFeature?._name + "PropertyGroup"}><b>Group:</b> ' + this.matchingFeature?._name + 'PropertyGroup' + '</a>',
                    name: `<a href="/#/data-catalogue/feature/${this.featureName}/property-group/${this.featureName}PropertyGroup"><b>Group: </b>${this.featureName}PropertyGroup</a>`,
                    children: [
                        { name: `<a href="/#/data-catalogue/feature/${this.featureName}/${this.featureName}PropertyGroup/designator">designator</a>` },
                        { name: `<a href="/#/data-catalogue/feature/${this.featureName}/${this.featureName}PropertyGroup/type">type</a>` },
                        { name: `<a href="/#/data-catalogue/feature/${this.featureName}/${this.featureName}PropertyGroup/name">name</a>` },
                        {
                            name: `<a href="/#/data-catalogue/feature/${this.featureName}/${this.featureName}PropertyGroup/location">location</a>`,
                            children: [
                                {
                                    name: `<a href="/#/data-catalogue/feature/${this.featureName}/property-group/PointType"><b>Group: </b> PointType</a>`,
                                    children: [
                                        { name: `<a href="/#/data-catalogue/feature/${this.featureName}/PointType/gml:pos">gml:pos</a>` },
                                        {
                                            name: `<a href="/#/data-catalogue/feature/${this.featureName}/property-group/PointPropertyGroup"><b>Group: </b> PointPropertyGroup</a>`,
                                            children: [
                                                { name: `<a href="/#/data-catalogue/feature/${this.featureName}/PointPropertyGroup/horizontalAccuracy">horizontalAccuracy</a>` },
                                                { name: `<a href="/#/data-catalogue/feature/${this.featureName}/PointPropertyGroup/annotation">annotation</a>` }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ];
        } else if (this.propertyGroupName?.includes('PropertyGroup') && this.propertyGroupName !== 'PointPropertyGroup') {
            this.treeData = [
                { name: `<a href="/#/data-catalogue/feature/${this.featureName}/${this.featureName}PropertyGroup/designator">designator</a>` },
                { name: `<a href="/#/data-catalogue/feature/${this.featureName}/${this.featureName}PropertyGroup/type">type</a>` },
                { name: `<a href="/#/data-catalogue/feature/${this.featureName}/${this.featureName}PropertyGroup/name">name</a>` },
                {
                    name: `<a href="/#/data-catalogue/feature/${this.featureName}/${this.featureName}PropertyGroup/location">location</a>`,
                    children: [
                        {
                            name: `<a href="/#/data-catalogue/feature/${this.featureName}/property-group/PointType"><b>Group: </b> PointType</a>`,
                            children: [
                                { name: `<a href="/#/data-catalogue/feature/${this.featureName}/PointType/gml:pos">gml:pos</a>` },
                                {
                                    name: `<a href="/#/data-catalogue/feature/${this.featureName}/property-group/PointPropertyGroup"><b>Group: </b> PointPropertyGroup</a>`,
                                    children: [
                                        { name: `<a href="/#/data-catalogue/feature/${this.featureName}/PointPropertyGroup/horizontalAccuracy">horizontalAccuracy</a>` },
                                        { name: `<a href="/#/data-catalogue/feature/${this.featureName}/PointPropertyGroup/annotation">annotation</a>` }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        } else if (this.propertyGroupName === 'PointType') {
            this.treeData = [
                {
                    name: `<a href="/#/data-catalogue/feature/${this.featureName}/property-group/PointType"><b>Group: </b> PointType</a>`,
                    children: [
                        { name: `<a href="/#/data-catalogue/feature/${this.featureName}/PointType/gml:pos">gml:pos</a>` },
                        {
                            name: `<a href="/#/data-catalogue/feature/${this.featureName}/property-group/PointPropertyGroup"><b>Group: </b> PointPropertyGroup</a>`,
                            children: [
                                { name: `<a href="/#/data-catalogue/feature/${this.featureName}/PointPropertyGroup/horizontalAccuracy">horizontalAccuracy</a>` },
                                { name: `<a href="/#/data-catalogue/feature/${this.featureName}/PointPropertyGroup/annotation">annotation</a>` }
                            ]
                        }
                    ]
                }
            ]
        } else if (this.propertyGroupName === 'PointPropertyGroup') {
            this.treeData = [
                { name: `<a href="/#/data-catalogue/feature/${this.featureName}/PointPropertyGroup/horizontalAccuracy">horizontalAccuracy</a>` },
                { name: `<a href="/#/data-catalogue/feature/${this.featureName}/PointPropertyGroup/annotation">annotation</a>` }
            ]
        }
    }

    ngOnInit() {
        this.featureName = this.route.snapshot.paramMap.get('featureId');
        this.propertyGroupName = this.route.snapshot.paramMap.get('propertyGroupId');

        this.route.paramMap.subscribe(params => {
            this.featureName = params.get('featureId');
            this.propertyGroupName = params.get('propertyGroupId');
        });

        this.mapTreeData();
    }
}